export const requireBookVisitFirstContactDate = (schema = {}) => ({
  ...schema,
  fields: (schema.fields ?? []).map((field) =>
    field.key === "first_contact_date" ? { ...field, required: true } : field,
  ),
});
